var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcId = function SvgIcId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 2.415a3.085 3.085 0 1 0 0 6.17 3.085 3.085 0 0 0 0-6.17ZM5.5 5.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM11 15.6c-1.73 0-3.442.515-4.967 1.512-1.526 1-2.814 2.45-3.717 4.224a1.233 1.233 0 0 1-1.64.536 1.19 1.19 0 0 1-.547-1.61c1.08-2.118 2.642-3.899 4.549-5.147C6.585 13.866 8.767 13.2 11 13.2c2.233 0 4.414.668 6.323 1.917 1.906 1.247 3.468 3.028 4.548 5.146a1.19 1.19 0 0 1-.547 1.61 1.233 1.233 0 0 1-1.64-.536c-.903-1.774-2.191-3.225-3.717-4.224C14.443 16.115 12.73 15.6 11 15.6Z"
  }))));
};
export default SvgIcId;